// src/Api.js
import axios from "axios";
import { loadAuth, clearAuth } from "./auth";

const api = axios.create({
  baseURL: "https://cloudsystem.com.mx/api/api.php",
  headers: { "Content-Type": "application/json" },
});

// 👉 Adjunta token si lo guardaste
api.interceptors.request.use((config) => {
  const auth = loadAuth();
  if (auth?.token) {
    config.headers.Authorization = `Bearer ${auth.token}`;
  }
  return config;
});

// 👉 Si la API responde {success:false}, trata como error
api.interceptors.response.use(
  (res) => {
    if (res?.data && res.data.success === false) {
      const err = new Error(res.data.error || res.data.message || "Error de la API");
      err.response = { data: res.data, status: res.status };
      throw err;
    }
    return res;
  },
  (error) => {
    // Si el backend un día devuelve 401, limpiamos sesión
    if (error?.response?.status === 401) {
      clearAuth();
      // opcional: window.location = "/";
    }
    return Promise.reject(error);
  }
);

export default api;
